import { useState } from "react";

export default function TeamForm({ onSubmit, team }: { onSubmit: (data: any) => void, team?: any }) {

    const isNew = team === null || team === undefined;

    const [form, setForm] = useState({
        name: team?.name ?? "",
        shortname: team?.shortname ?? "",
        description: team?.description ?? "",
    });

    function updateField(key, value) {
        setForm(prev => ({ ...prev, [key]: value }));
    }

    function handleSubmit(e) {
        e.preventDefault();
        onSubmit(form);
    }

    return (
        <form onSubmit={handleSubmit} className="space-y-6 max-w-xl mx-auto p-6 bg-white rounded-xl shadow">

            <h2 className="text-2xl font-semibold mb-4">{isNew ? "Create Team" : "Edit Team"}</h2>

            <div>
                <label className="block text-sm font-medium mb-1">Name</label>
                <input
                    type="text"
                    defaultValue={form.name}
                    onChange={(e) => updateField("name", e.target.value)}
                    className="w-full px-3 py-2 border border-gray-300 rounded-lg
                               focus:outline-none focus:ring-2 focus:ring-indigo-500"
                />
            </div>
            <div>
                <label className="block text-sm font-medium mb-1">Shortname</label>
                <input
                    type="text"
                    defaultValue={form.shortname}
                    onChange={(e) => updateField("shortname", e.target.value)}
                    className="w-full px-3 py-2 border border-gray-300 rounded-lg
                               focus:outline-none focus:ring-2 focus:ring-indigo-500"
                />
            </div>
            <div>
                <label className="block text-sm font-medium mb-1">Description</label>
                <input
                    type="text"
                    defaultValue={form.description}
                    onChange={(e) => updateField("description", e.target.value)}
                    className="w-full px-3 py-2 border border-gray-300 rounded-lg
                               focus:outline-none focus:ring-2 focus:ring-indigo-500"
                />
            </div>

            {/* SAVE BUTTON */}
            <button
                type="submit"
                className="w-full py-2 px-4 bg-indigo-600 text-white rounded-lg
                           hover:bg-indigo-700 transition font-medium"
            >
                {isNew ? "Create Team" : "Save Changes"}
            </button>
        </form>
    );
}